import { Table } from '~/components/Table/Table';
import { Link } from '~/components/Link/Link';
import { Series } from '~/apis/ssf';
import { scoringSystemNameToLabel } from '~/utils/scoring-system';
import { genderNameToLabel } from '~/utils/gender';

interface Props {
  series: Series[];
  isLoading: boolean;
}

function Row({ serie }: { serie: Series }) {
  return (
    <Table.Row>
      <Table.Col>
        <Link to={`${serie.id}`}>{serie.name}</Link>
      </Table.Col>
      <Table.Col>{serie.year}</Table.Col>
      <Table.Col>{serie.competition_type.description}</Table.Col>
      <Table.Col>{genderNameToLabel(serie.gender)}</Table.Col>
      <Table.Col>{scoringSystemNameToLabel(serie.scoring_system)}</Table.Col>
    </Table.Row>
  );
}

export function SerieListTable({ series, isLoading }: Props) {
  return (
    <Table bg="even">
      <Table.Head>
        <Table.Row>
          <Table.Col as="th">Namn</Table.Col>
          <Table.Col as="th">År</Table.Col>
          <Table.Col as="th">Typ</Table.Col>
          <Table.Col as="th">Kön</Table.Col>
          <Table.Col as="th">Poängsystem</Table.Col>
        </Table.Row>
      </Table.Head>
      <Table.Body>{isLoading ? <Table.Loading cols={5} /> : series.map(s => <Row serie={s} key={s.id} />)}</Table.Body>
    </Table>
  );
}
